<template>
  <div class="bbp-select-manager">
    <div class="bbp-select-manager-image-container"
         v-if="(index <= limitCount) || openListAddedManager || manager === 'new' || type === 'project'"
         :class="{
           'bbp-select-manager-image-container_with-hover': manager !== 'new' && !viewMode && checkCountManager
         }"
         @click="openControls"
         v-click-outside="closeControls"
         @mouseenter="setDisplayPopup($event, true)"
         @mouseleave="setDisplayPopup($event, false)">
      <transition name="bbp-bounce">
        <div class="bbp-select-manager-image-container-popup"
             @mouseleave="closeControls"
             :style="popupPosition" v-if="controlsDisplay">
          <div class="bbp-select-manager-image-container-popup__item" @click.stop="editPM">Edit</div>
          <div class="bbp-select-manager-image-container-popup__item" @click.stop="deletePM">Delete</div>
        </div>
      </transition>
      <template v-if="index === limitCount && !openListAddedManager && type !== 'project'">
        <div class="bbp-select-manager-image-container__image bbp-select-manager-image-container__image_total"
             tabindex="0"
             @click.stop="openSelectAddedManager">
          {{countAddedSupport}}
        </div>
      </template>
      <template v-else-if="manager !== 'new'">
        <img
          v-if="photo"
          class="bbp-select-manager-image-container__image"
          :src="photo"
        >
        <i
          v-else-if="managerId"
          class="bbp-icon-user bbp-select-manager-image-container__image"
        />
        <div
          v-else
          class="bbp-select-manager-image-container__image bbp-select-manager-image-container__image_none"
        >
          !
        </div>
      </template>
      <template v-else>
        <div
          v-if="supportManagers.length < 1 "
          class="bbp-select-manager-image-container__image bbp-select-manager-image-container__image_new"
             tabindex="1"
             @keyup.esc="closeList"
             @click.stop="openSelectManager">
          <i class="bbp-icon-plus"/>
        </div>
      </template>
      <transition name="bbp-slide-select">
       <div class="bbp-select-manager-list__wrapper"
            :class="{'bbp-select-manager-list__wrapper_first': index === 0}"
            @mouseenter="setDisplayPopup($event, false)"
            v-if="openList">
         <VuePerfectScrollbar class="bbp-select-manager-list"
                              v-click-outside="closeList"
                              @click.stop
                              tabindex="0"
                              @keyup.esc="closeList"
                              :settings="scrollSettings">
           <div class="bbp-select-manager-list__margin bbp-select-manager-list__margin_top"/>
           <div class="bbp-select-manager-list-user"
                @click.stop="setSupport(user)"
                v-for="user in usersList"
                :key="user._id">
             <img class="bbp-select-manager-list-user__image" :src="getUserImage(user)" v-if="user.image"/>
             <i class="bbp-icon-user bbp-select-manager-list-user__image" v-else/>
             <span class="bbp-select-manager-list-user__username">{{user.username}}</span>
           </div>
           <div class="bbp-select-manager-list__margin bbp-select-manager-list__margin_bottom"/>
         </VuePerfectScrollbar>
       </div>
      </transition>
      <transition name="bbp-bounce">
        <div class="bbp-select-manager-popup"
             v-if="manager && manager.username && hoverImage && !controlsDisplay"
             :style="popupPosition">
          {{addedUser}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {get, uniqBy, compact} from 'lodash'
import UserApi from '@/api/Users/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import filterByDepartment from '@/mixin/filterByDepartment'

export default {
  name: 'BBPSelectManager',
  props: [
    'manager',
    'order',
    'openListAddedManager',
    'limitCount',
    'supportManagers',
    'department',
    'setOn',
    'type',
    'project',
    'index',
    'isHidePlus',
    'viewMode'
  ],
  components: {
    VuePerfectScrollbar
  },
  mixins: [filterByDepartment],
  data () {
    return {
      hoverImage: false,
      popupPosition: {},
      usersTotalDocs: -1,
      usersLimit: 9999,
      openList: false,
      controlsDisplay: false,
      scrollSettings: { wheelPropagation: false, minScrollbarLength: 25 }
    }
  },
  computed: {
    photo () {
      return get(this.manager, 'image.path', '')
    },
    managerId () {
      return get(this.manager, '_id', '')
    },
    typeCode () {
      const typeCodes = {
        support: 1,
        project: 2
      }
      return typeCodes[this.type]
    },
    checkCountManager () {
      return this.index !== this.limitCount
    },
    addedUser () {
      return this.index === this.limitCount && !this.openListAddedManager
        ? `and ${this.supportManagers.length - this.limitCount} more`
        : this.manager.username
    },
    usersList () {
      const selectedSupport = get(this.project, 'supportManager', [])

      const filteredUsers = this.sortUsersByDepartment(this.usersListProjects, this.department)
      filteredUsers.filter((user) => {
        const userId = get(user, '_id', '')
        return !selectedSupport.includes(userId)
      })

      return compact(uniqBy(filteredUsers, '_id'))
    },
    countAddedSupport () {
      return this.supportManagers.length - this.limitCount
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    }
  },
  methods: {
    editPM () {
      this.closeControls()
      this.openSelectManager()
    },
    deletePM () {
      this.closeControls()
      this.setSupport({})
      if (this.countAddedSupport === 0 && this.openListAddedManager) {
        this.$emit('openListManager', this.openListAddedManager)
      }
    },
    openControls () {
      if (this.viewMode || this.manager === 'new') return
      this.controlsDisplay = !this.controlsDisplay
    },
    closeControls () {
      this.controlsDisplay = false
    },
    setSupport (user) {
      this.closeList()
      this.$emit('setManager', {user, type: this.typeCode, oldManager: this.manager})
    },
    closeList () {
      this.openList = false
    },
    getUserImage (user) {
      return get(user, 'image.path', '')
    },
    openSelectManager () {
      this.openList = !this.openList
      if (!this.openList) return
      this.getUsersListSelect()
    },
    openSelectAddedManager () {
      this.hoverImage = false
      this.$emit('openListManager', this.openListAddedManager)
    },
    async getUsersListSelect () {
      if (this.usersListProjects.length) return
      try {
        const { data } = await UserApi.getUsersListSelect({})
        this.usersListProjects = data
      } catch (err) {
        console.error(err)
      }
    },
    setDisplayPopup (e, val) {
      this.hoverImage = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + position.height + 4 + 'px',
          left: 'auto'
        }
      } else {
        this.closeControls()
        this.popupPosition = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-select-manager {
    @include global-font;
    display: flex;
    align-items: center;
    justify-content: center;

    &-image-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 3px solid $color-link-water;
      background-color: $color-link-water;
      box-sizing: border-box;
      transition: 0.3s;
      cursor: pointer;

      &_with-hover {
        &:after {
          font-family: "bb-projects", serif;
          content: '\E814';
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          left: -1px;
          top: -1px;
          width: 30px;
          height: 30px;
          opacity: 0;
          border-radius: 50%;
          background-color: rgba($color-white, 0.85);
          font-size: 12px;
          color: $color-accent;
          transition: 0.3s;
        }

        &:hover {
          &:after {
            opacity: 1;
          }
        }
      }

      &__image {
        width: 28px;
        height: 28px;
        color: $color-accent;
        object-fit: cover;
        font-size: 28px;
        border-radius: 50%;
        transition: 0.3s;

        &_none {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          background-color: $color-mercury;
          color: $color-pomegranate;
        }

        &_total {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          background-color: $color-sail;
        }

        &_total {
          background-color: $color-sail;
        }

        &_new {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          background-color: $color-link-water;

          &:hover {
            background-color: $color-white;
          }
        }

        &:before {
          margin: 0;
        }
      }

      &-popup {
        position: absolute;
        bottom: -73px;
        left: auto;
        min-height: 68px;
        max-height: 68px;
        min-width: 92px;
        max-width: 92px;
        background: $color-white;
        box-shadow: 0 0 15px rgba($color-black, 0.12);
        border-radius: 4px;
        z-index: 5;

        &__item {
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          color: $color-black;
          padding: 10px;
          transition: 0.3s;

          &:hover {
            color: $color-accent;
          }

          &:last-child {
            box-sizing: border-box;
            border-top: 1px solid $color-wild-sand;
          }
        }

        &:before {
          content: '';
          position: absolute;
          left: 40px;
          top: -6px;
          display: block;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid $color-white;
        }
      }
    }

    &-list {
      overflow: hidden;
      max-height: 194px;
      padding: 0 8px;

      &__wrapper {
        position: absolute;
        top: 34px;
        left: 1px;
        width: auto;
        min-width: 170px;
        background-color: $color-white;
        box-shadow: 0 0 12px rgba($color-black, 0.12);
        border-radius: 5px;
        z-index: 3;

        &:before {
          content: '';
          position: absolute;
          left: 8px;
          top: -5px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent $color-white transparent;
        }
      }

      &__margin {
        position: sticky;
        background-color: $color-white;
        height: 10px;
        width: 100%;
        z-index: 2;

        &_top {
          top: 0;
        }

        &_bottom {
          bottom: 0
        }
      }

      &-user {
        display: grid;
        grid-template-columns: 28px auto;
        grid-gap: 8px;
        align-items: center;
        margin-bottom: 8px;
        font-size: 13px;
        line-height: 16px;
        text-transform: capitalize;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          color: $color-accent;
        }

        &__image {
          width: 28px;
          height: 28px;
          color: $color-accent;
          object-fit: cover;
          font-size: 28px;
          border-radius: 50%;

          &:before {
            margin: 0;
          }
        }

        &__username {
          color: $color-black;
        }
      }
    }

    &-popup {
      position: absolute;
      left: auto;
      top: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      padding: 4px 7px;
      background: rgba($color-black, 0.55);
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      color: $color-white;
      border-radius: 3px;
      z-index: 20;
      pointer-events: none;
      text-transform: capitalize;
      user-select: none;

      &:before {
        content: '';
        position: absolute;
        left: auto;
        top: -3px;
        display: block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 3px solid rgba($color-black, 0.55);;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/InputFields/BBPSelectManager/BBPSelectManager.vue